const themeQuery = (slug: string | string[] | undefined) => {
  return `
  *[_type == "theme" && slug.current == "${slug}"]{
      'slug': slug.current,
      demoSectionDescription,
      demoSectionTitle,
      excerpt,
      title,
      price,
      gtagId,
      pageTitle,
      themeDesktop, 
      themeMobile,
      metaTitle,
      metaDescription,
      ogImage,
      ctaSectionTitle,
      ctaSectionDescription,
      ctaGallery,
      footerCtaSectionTitle,
      footerCtaSectionDescription,
      footerCtaGallery,
      _id,
      _type,
      _updatedAt,
      _createdAt,
      demoList,
      documentationLink,
      content
  }[0]
  `;
};

export default themeQuery;
